export const FORM_CONSTANT = {
  BACK_SPACE: "Backspace",
  DECIMAL: "decimal",
  FILE: "file",
  MOBILE_NUMBER: "mobileNumber",
  NAME: "name",
  NUMBER: "number",
  OBJECT: "object",
  TEXT: "text",
};
